var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"stackedColumns3dChart",staticStyle:{"width":"100%","background-color":"#FFFFFF"},style:({height: _vm.chartHeight+'px'})})}
var staticRenderFns = []

export { render, staticRenderFns }